import React, { useState, useEffect } from 'react';
import { useAuth } from './vmAuthenticate';
import { usePanelNavigation } from './vmSlidingPanel';
import { VMWelcomePanel } from './vmWelcome';
import { firebaseService } from '../firebase';
import { getAuth, isSignInWithEmailLink } from 'firebase/auth';
import { VMAuthStorage } from './vmAuthStorage';

export const VMAuthPanel = ({ changeSection }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isPasswordless, setIsPasswordless] = useState(true);
  const { login, register } = useAuth();
  const { goBack, pushPanel } = usePanelNavigation();

  // Check for email sign-in link on component mount
  useEffect(() => {
    const auth = getAuth();
    const href = window.location.href;

    if (isSignInWithEmailLink(auth, href)) {
      const email = VMAuthStorage.getSignInEmail();
      if (email) {
        handleEmailLinkSignIn(email, href);
      } else {
        setError('Please provide your email address to complete sign-in');
      }
    }
  }, []);

  const handleEmailLinkSignIn = async (email, href) => {
    console.log("Attempting email link sign-in with:", { email, href });
    try {
      const result = await firebaseService.completeSignInWithLink(email, href);
      console.log("Email Link Sign-In Result:", result);

      if (result.success) {
        //window.localStorage.removeItem('emailForSignIn');
        //localStorage.removeItem('pendingAuthUrl');
        //console.log("success result, Setting systemUserId:", result.userId);
        // Store the system user ID
        //localStorage.setItem('systemUserId', result.userId);

        // Show welcome panel
        pushPanel(
          <VMWelcomePanel
            email={email}
            user_uuid={result.userId}
            changeSection={changeSection}
            isNewUser={false}
          />
        );
      } else {
        console.error("Email link sign-in failed:", result.error);
        setError(result.error);
      }
    } catch (error) {
      console.error("Email Link Sign-In Error:", error);
      setError(error.message);
    }
  };

  const handleSignIn = async () => {
    if (!email) {
      setError('Please enter your email');
      return;
    }

    if (isPasswordless) {
      try {
        VMAuthStorage.setSignInEmail(email);
        const result = await firebaseService.sendSignInLink(email);
        console.log("Sent sign in link? result ", result);
        if (result.success) {
          setMessage('Check your email for the sign-in link!');
          setError('');
        } else {
          setError(result.error);
        }
      } catch (error) {
        setError(error.message);
      }
      return;
    }

    if (!password) {
      setError('Please enter your password');
      return;
    }

    const result = await login(email, password);
    if (result.success) {
      pushPanel(
        <VMWelcomePanel
          email={email}
          user_uuid={result.userId}
          changeSection={changeSection}
          isNewUser={false}
        />
      );
    } else {
      setError(result.error);
    }
  };

  const handleCreateAccount = async () => {
    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }
    const result = await register(email, password);
    if (result.success) {
      pushPanel(
        <VMWelcomePanel
          email={email}
          user_uuid={result.userId}
          changeSection={changeSection}
          isNewUser={true} 
        />
      );
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="vm-section">
      <div className="vm-section-title">
        <h2>Welcome to Vote Machine</h2>
      </div>

      <div className="vm-form-vertical">
        <input
          type="email"
          className="vm-form-input"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {!isPasswordless && (
        <input
          type="password"
          className="vm-form-input"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        )}

        {error && <div className="vm-form-error">{error}</div>}
        {message && <div className="vm-form-success">{message}</div>}

        <div className="vm-proposal-vote-button-container">
          {!isPasswordless && (
            <button
              className="vm-form-button"
              onClick={handleCreateAccount}
            >
              Sign Up
            </button>
          )}
          <button
            className="vm-form-button"
            onClick={handleSignIn}
          >
            {isPasswordless ? 'Send Sign-in Link' : 'Sign In'}
          </button>
        </div>

        <div className="vm-proposal-vote-button-container">
            <button
              className="vm-form-link"
              onClick={() => setIsPasswordless(!isPasswordless)}
            >
              {isPasswordless ? 'Use password instead' : 'Sign in with email link'}
            </button>
          </div>

      </div>
    </div>
  );
};